import {
  axios,
  config
} from '../api'
import store from '../store'

let bill = {}

bill.getEditDto = (_ID) => {
  return axios('post', config.API_URL + '/api/Bill/GetEditDto', {},{
    ID: _ID
  })
}

bill.add = {
  data: {
    XiaoXiang: "",
    LastPayDate: "",
    Money: 0,
    BeginDate:'',
    EndDate:'',
    Source:'',
    ShopIDs:'',
    ContractID:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Bill/Add', _data)
  }
}

bill.edit = {
  data: {
    XiaoXiang: "",
    LastPayDate: "",
    Money: 0,
    BeginDate:'',
    EndDate:'',
    Source:'',
    ShopIDs:'',
    ContractID:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Bill/Edit', _data)
  }
}

bill.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Bill/GetList', _data)
  }
}

bill.export = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Bill/ExportList',_data,{},1)
  }
}

bill.del = (_idList) => {
  return axios('post', config.API_URL + '/api/Bill/Del',{}, {
    idList: _idList
  })
}

bill.pay = {
  data: {
    BillIdList: [],
    PayID: '',
    BillID: '',
    PayDay: '',
    Money: '',
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/BillPay/Add', _data)
  }
}

bill.payList = { //分页获取缴费记录
  data: {
    PageIndex: 1,
    PageSize: 500,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/BillPay/GetList', _data)
  }
}

export default bill



